// import axios from "axios";
//import axios from "./productInstance";
import axios from 'axios';
import {Company} from "@/types/user";

export default async (token?: string) => {
    const PRODUCT_API_URL = import.meta.env.VITE_API_URL_PRODUCT
    try {
      if (!token) {
        return;
      }
      const config = {
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            Authorization: `Bearer ${token}`,
          }
      };
      const response: any = await axios.get(`${PRODUCT_API_URL}/v2/companies/`, config)
      return response.data.sort((a: Company, b: Company) => a.id?.localeCompare(b.id || ""));
    } catch (error: any) {
      console.error('Error:', error)
      return [];
    }
}
